<template>
	<div class="inner-modal inner-modal--dff">
		<div class="dff">
			<div class="dff__inner">
				<DFFIntro v-if="activeComponent === 'intro'" :key="activeComponent"></DFFIntro>

				<template v-if="activeComponent === 'questions'" v-for="q in questions" :key="q.id">
					<DFFQuestion
						v-if="activeQuestion(q.id)"
						:questionref="generateRef(q.id)"
						:questionobject="q"
						:question="q.question"
						:answers="q.answers"
					></DFFQuestion>
				</template>

				<DFFLoading v-if="activeComponent === 'loading'" :key="activeComponent"></DFFLoading>
			</div>
		</div>
		<button @click="closeModal" class="inner-modal__close">&times;</button>
	</div>
</template>

<script lang="ts" setup>
import {computed, ref} from 'vue';
import jsonData from 'Data/doorfitfinder.json';
import DFFQuestion from 'Vue/components/lockDesigner/components/DFFQuestion.vue';
import DFFIntro from 'Vue/components/lockDesigner/components/DFFIntro.vue';
import DFFLoading from 'Vue/components/lockDesigner/components/DFFLoading.vue';
const questions = jsonData.questions;
const componentName = 'DoorFitFinderModal';
import { useStore } from 'vuex';
const store = useStore();

const activeComponent = computed(() => {
	return store?.state?.doorFitFinder?.activeComponent;
});

const generateRef = (id) => {
	return ref(id);
};
const activeQuestion = (id) => {
	return store?.state?.doorFitFinder?.activeQuestion === id;
};

const closeModal = () => {
	store.dispatch('closeModal');
	store.commit('resetDoorFitFinderSelections', {
		activeComponent: "intro",
		prevQuestion: "",
		activeQuestion: "Q1",
		existingHardware: "",
		lock: null,
		doorEdge: ""
	})
};

</script>
